import { FormController } from '@form-ts/core';
import { UserFormData } from 'src/modules/common/types/UserFormData';
import { FormError } from 'src/modules/form/types/FormError';
import { ChangePasswordData } from 'src/modules/profile/types/ChangePasswordData';
import { ProfileSyncMode } from 'src/modules/profile/types/ProfileSyncMode';
import { createActions } from 'src/utils/createActions';
import { createTrigger } from 'src/utils/createTrigger';

export const PROFILE_CHANGE = createTrigger<UserFormData, void>('PROFILE_CHANGE');
export const PROFILE_SYNC_PERFORM = createActions<
ProfileSyncMode,
UserFormData,
UserFormData>('PROFILE_SYNC_PERFORM');
export const PROFILE_SYNC_RESET = createTrigger<void>('PROFILE_SYNC_RESET');

export const PROFILE_CHANGE_PASSWORD =
  createActions<FormController<ChangePasswordData, FormError>, void>('PROFILE_CHANGE_PASSWORD');

export const PROFILE_LATEST_ACTIVITY = createActions<void, void>('PROFILE_LATEST_ACTIVITY');
